// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_heading__QLKZz {
  font-family: "Poppins", sans-serif;
  font-size: 36px;
  font-weight: 700;
  color: #313333;
}

.styles_sidebar__x5oPa {
  max-width: 255px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/layout/styles.module.scss","webpack://./src/constants/fonts.scss","webpack://./src/constants/colors.scss"],"names":[],"mappings":"AAGA;EACE,kCCFQ;EDGR,eAAA;EACA,gBAAA;EACA,cENM;AFKR;;AAKA;EACE,gBAAA;AAFF","sourcesContent":["@import 'constants/fonts.scss';\n@import 'constants/colors.scss';\n\n.heading {\n  font-family: $poppins;\n  font-size: 36px;\n  font-weight: 700;\n  color: $black\n}\n\n\n.sidebar {\n  max-width: 255px;\n}\n","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap');\n\n$poppins: 'Poppins', sans-serif;\n$roboto: 'Roboto', sans-serif;\n$inter: 'Inter', sans-serif;\n","$gray: #6C7275;\n$black: #313333;\n$blue: #0084FF;\n$green: #29B473;\n$white: #FEFEFE;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `styles_heading__QLKZz`,
	"sidebar": `styles_sidebar__x5oPa`
};
export default ___CSS_LOADER_EXPORT___;
